export const LOGGER = {
  EventCat: {
    Button: 'Button',
    Interval: 'Interval',
    RequestResponse: 'RequestResponse',
  },
  EventAction: {
    Add: 'Add',
    Navigate: 'Navigate',
    Submit: 'Submit',
    Save: 'Save',
    Search: 'Search',
    Delete: 'Delete',
    Upload: 'Upload',
    Update: 'Update',
    Login: 'Login',
    Download: 'Download',
  },
  logEvent: (eventAction, eventCategory, eventLabel, eventValue) => {
    const eventData = {
      action: eventAction,
      category: eventCategory,
      label: eventLabel,
      value: eventValue,
      timestamp: new Date().toISOString(),
    }
    console.log(`[Event Logged]`, JSON.stringify(eventData, null, 2))
  },
  logException: (error, fatal = false) => {
    // If 'error' is just a string, convert it to an Error object
    const errObj = typeof error === 'string' ? new Error(error) : error
    const exceptionData = {
      description: errObj.message || String(errObj),
      stack: errObj?.stack,
      fatal,
      timestamp: new Date().toISOString(),
    }
    console.error(`[Exception Logged]`, JSON.stringify(exceptionData, null, 2))
  },
}
